import { Division, Flex, Heading, Icon, Icons, Paragraph } from "@ir/ui";
import { activeCountLabel } from "./activeCountLabel";

export const BrandDetailsPurchasersHeader = ({
  activePurchasersCount,
}: {
  activePurchasersCount: number;
}) => {
  const label = activeCountLabel(
    activePurchasersCount,
    "purchaser",
    "Purchasers",
  );

  return (
    <Flex align="center">
      <Icon name={Icons.List} color="primary" />
      <Division style={{ marginLeft: "0.75rem", flex: 1 }}>
        <Heading level={6} className="text-grey-700 font-bold m-0">
          Purchasers
        </Heading>
        <Paragraph
          className="text-grey-500 font-regular m-0"
          style={{ fontSize: "0.8rem" }}
        >
          {label}
        </Paragraph>
      </Division>
    </Flex>
  );
};
